export enum LimitedFeatures {
  Pdf = 'pdf',
  Excel = 'excel',
  Trip = 'trip',
  Client = 'client',
  GraphComparison = 'graphComparison',
  BulkUpload = 'bulkUpload',
  CreateUser = 'createUser',
  Generic = 'generic',
}
